import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/hooks/useAuth';

interface PublicRouteProps {
  redirectTo?: string;
  children?: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  redirectTo = '/home',
  children
}) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  if (isAuthenticated) { 
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }
  
  return children ? <>{children}</> : <Outlet />;
};

export default PublicRoute;